<!--
 * @Author: wsx
 * @Date: 2022-01-14 10:26:06
 * @LastEditTime: 2022-06-13 12:03:18
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description: 街道
-->
<template>
  <div class="StreetTable">
    <h-table
      ref="tableRef"
      v-model:columns="columns"
      :method="leftListquery"
      :params="tableParams"
      @handleClick="handleClick"
    >
      <template #deptLost="{ row }">
        <template v-for="(item, index) in row.deptList" :key="index">
          <h-button size="small">
            {{ item.name }}
          </h-button>
        </template>
      </template>
    </h-table>
  </div>
  <regionTransferApplication
    v-if="regionVisible"
    v-model:visible="regionVisible"
    :regionInfo="region"
    :rowInfo="tableRow"
  ></regionTransferApplication>
</template>
<script>
import { defineComponent, reactive, toRefs, watch, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  leftListquery,
  regioninfodelete,
  regioninfoexport,
} from "@/api/system/region";

import HButton from "../../../../components/global/HButton.vue";
import regionTransferApplication from "./regionTransferApplication.vue";
// import { util } from "echarts";
import util from "@util/js";
export default defineComponent({
  name: "StreetTable",
  components: { HButton, regionTransferApplication },
  props: {
    region: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, context) {
    const state = reactive({
      tableParams: {
        // apiType: 'street',
        type: "0",
        id: "",
      },
      moveVisible: false,
      columns: [
        { type: "index" },
        {
          label: "街道名称",
          prop: "name",
        },
        {
          label: "所属部门",
          slot: "deptLost",
        },
        {
          label: "经度",
          prop: "longitude",
        },
        {
          label: "纬度",
          prop: "latitude",
        },
        {
          type: "operate",
          label: "操作",
          width: "190px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "详情", emitKey: "detils" },
            { name: "编辑设备", emitKey: "editEquipe" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      regionVisible: false,
      tableRow: {},
    });
    const tableRef = ref(null);
    const refData = toRefs(state);

    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    watch(
      () => props.region,
      (v) => {
        if (v.type !== "root") {
          state.tableParams.id = v.id;
          // state.tableParams.type = v.type;
        }
        refreshTable();
      },
      { immediate: true, deep: true }
    );
    // 列表导出
    const exporting = async () => {
      let params = { allowpage: true, ...state.tableParams };
      regioninfoexport(params).then((res) => {
        util.exporting(res);
      });
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        context.emit("editOrgan", row);
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该街道信息吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          async () => {
            const res = await regioninfodelete([row.regionId]);
            if (res.code === 0) {
              refreshTable();
              context.emit("updateOrgan");
              ElMessage({
                type: "success",
                message: "删除成功",
              });
            }
          },
          () => {}
        );
      } else if (emitKey === "editEquipe") {
        state.tableRow = row;
        state.regionVisible = true;
      } else if (emitKey === "detils") {
        context.emit("detils", row);
      }
    };
    return {
      ...refData,
      leftListquery,
      tableRef,
      handleClick,
      exporting,
    };
  },
});
</script>
<style lang="scss" scoped>
.StreetTable {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .organTransfer {
    height: 400px;
  }
}
</style>
